import { Card, CardMedia } from "@mui/material";

const IntroCard = () => {
  return (
    <>
      {" "}
      {/* introImage */}
      <div className="flex flex-row m-4 md:mx-40 ">
        <Card
          sx={{
            boxShadow: 3,
            margin: { sm: 1, md: 4 },
            marginTop: { sm: 4, md: 4 },
            borderRadius: 10,
          }}
        >
          <CardMedia style={{ width: "100%" }}>
            <img
              src={require("../../assets/images/companyPhoto.png")}
              alt="company"
            ></img>
          </CardMedia>
        </Card>
      </div>
    </>
  );
};

export default IntroCard;
